import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe, NgOptimizedImage } from '@angular/common';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AlertModule } from 'ngx-bootstrap/alert';
import { SwitchButtonComponent } from './components/switch-button/switch-button.component';
import { ModalComponent } from './components/modal/modal.component';
import { AlertComponent } from './components/alert/alert.component';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterComponent } from './components/filter/filter.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { MultiChartsComponent } from './components/multi-charts/multi-charts.component';
import { StackedBarComponent } from './components/stacked-bar/stacked-bar.component';
import { SimpleTableComponent } from './components/simple-table/simple-table.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import {
  NzCellEllipsisDirective,
  NzTableComponent,
  NzThAddOnComponent,
  NzThMeasureDirective,
} from 'ng-zorro-antd/table';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { RouterLink } from '@angular/router';
import { NzEmptyComponent } from 'ng-zorro-antd/empty';
import { TableComponent } from './components/table/table.component';
import { NumbersValidationDirective } from './directives/numbers-validation.directive';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { StepLineChartComponent } from './components/step-line-chart/step-line-chart.component';
import { SuffixDirective } from './directives/suffix.directive';
import { NzSwitchComponent } from 'ng-zorro-antd/switch';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

const ngZoroModules = [
  NzSelectModule,
  NzRadioModule,
  NzPaginationModule,
  NzTimePickerModule,
  NzDatePickerModule,
  NzCheckboxModule,
  NzButtonModule,
  NzTabsModule,
  NzTooltipModule,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AccordionModule,
    ModalModule,
    TooltipModule,
    TranslateModule.forChild(),
    AlertModule,
    ...ngZoroModules,
    FormsModule,
    ReactiveFormsModule,
    NzTableComponent,
    NgOptimizedImage,
    NzThMeasureDirective,
    NzThAddOnComponent,
    BsDropdownModule,
    RouterLink,
    NzEmptyComponent,
    NzCellEllipsisDirective,
    NumbersValidationDirective,
    NzIconDirective,
    SuffixDirective,
    NzSwitchComponent,
    TranslatePipe,
    SwitchButtonComponent,
    AlertComponent,
    ModalComponent,
    FilterComponent,
    MultiChartsComponent,
    SimpleTableComponent,
    StackedBarComponent,
    TableComponent,
    ConfirmationModalComponent,
    StepLineChartComponent,
  ],
  exports: [
    SwitchButtonComponent,
    AlertComponent,
    ModalComponent,
    SimpleTableComponent,
    AccordionModule,
    TooltipModule,
    FilterComponent,
    MultiChartsComponent,
    StackedBarComponent,
    TableComponent,
    ConfirmationModalComponent,
    StepLineChartComponent,
  ],
  providers: [CurrencyPipe, DecimalPipe],
})
export class SharedModule {}
